"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNextDayAndTime = exports.OrderedDays = exports.textFromMonth = exports.textFromDay = exports.humanReadableTimeEpoch = exports.invoiceDate = exports.fileNameDate = exports.humanReadableDate = exports.humanReadableTime = exports.addSingleDuration = exports.nextMonth = exports.yesterday = exports.makeItTwo = exports.getTimeFromString = exports.setTime = exports.getHoursMinutes = exports.getDayEU = exports.fullDay = exports.midDay = exports.dayRatio = exports.hoursInDay = exports.hourRatio = exports.minutesInHour = exports.minuteRatio = exports.secondsInMinute = exports.secondRatio = void 0;
exports.secondRatio = 1000;
exports.secondsInMinute = 60;
exports.minuteRatio = exports.secondsInMinute * exports.secondRatio;
exports.minutesInHour = 60;
exports.hourRatio = exports.minutesInHour * exports.minuteRatio;
exports.hoursInDay = 24;
exports.dayRatio = exports.hoursInDay * exports.hourRatio;
exports.midDay = 12 * exports.hourRatio;
exports.fullDay = 24 * exports.hourRatio;
const getDayEU = (date) => {
    const dayUS = date.getDay();
    return dayUS === 0 ? 6 : dayUS - 1;
};
exports.getDayEU = getDayEU;
const getHoursMinutes = (time) => {
    const hours = Math.floor(time / exports.hourRatio);
    const minutes = Math.floor(time / exports.minuteRatio) % exports.minutesInHour;
    return { hours, minutes };
};
exports.getHoursMinutes = getHoursMinutes;
const setTime = (date, time) => {
    const { hours, minutes } = exports.getHoursMinutes(time);
    const tempDate = new Date(date.toISOString());
    return new Date(tempDate.setHours(hours, minutes, 0, 0));
};
exports.setTime = setTime;
const getTimeFromString = (value) => {
    const [hours, minutes] = value.split(":").map((string) => parseInt(string));
    return exports.minuteRatio * minutes + exports.hourRatio * hours;
};
exports.getTimeFromString = getTimeFromString;
const makeItTwo = (value) => ("0" + value).slice(-2);
exports.makeItTwo = makeItTwo;
exports.yesterday = new Date(new Date().valueOf() - 1 * exports.dayRatio);
exports.nextMonth = new Date(new Date().valueOf() + 31 * exports.dayRatio);
const addSingleDuration = (date) => new Date(date.valueOf() + 30 * exports.minuteRatio);
exports.addSingleDuration = addSingleDuration;
const humanReadableTime = (date) => {
    return `${exports.makeItTwo(date.getHours())}:${exports.makeItTwo(date.getMinutes())}`;
};
exports.humanReadableTime = humanReadableTime;
const humanReadableDate = (date) => {
    const textDate = `${exports.makeItTwo(date.getDate())}/${exports.makeItTwo(date.getMonth() + 1)}/${date.getFullYear()}`;
    return `${exports.humanReadableTime(date)} - ${textDate}`;
};
exports.humanReadableDate = humanReadableDate;
const fileNameDate = (date) => {
    const textDate = `${exports.makeItTwo(date.getFullYear())}-${exports.makeItTwo(date.getMonth() + 1)}-${date.getDate()}`;
    return textDate;
};
exports.fileNameDate = fileNameDate;
const invoiceDate = (date) => {
    const textDate = `${date.getDate()}/${exports.makeItTwo(date.getMonth() + 1)}/${date.getFullYear()}`;
    return textDate;
};
exports.invoiceDate = invoiceDate;
const humanReadableTimeEpoch = (time) => {
    return `${exports.makeItTwo(Math.floor(time / exports.hourRatio))}:${exports.makeItTwo(Math.floor((time % exports.hourRatio) / exports.minuteRatio))}`;
};
exports.humanReadableTimeEpoch = humanReadableTimeEpoch;
const textFromDay = (input) => {
    switch (input % 7) {
        case 0:
            return "Lundi";
        case 1:
            return "Mardi";
        case 2:
            return "Mercredi";
        case 3:
            return "Jeudi";
        case 4:
            return "Vendredi";
        case 5:
            return "Samedi";
        case 6:
            return "Dimanche";
        default:
            return "Y'a eu un soucis";
    }
};
exports.textFromDay = textFromDay;
const textFromMonth = (input) => {
    switch (input % 12) {
        case 0:
            return "Janvier";
        case 1:
            return "Février";
        case 2:
            return "Mars";
        case 3:
            return "Avril";
        case 4:
            return "Mai";
        case 5:
            return "Juin";
        case 6:
            return "Juillet";
        case 7:
            return "Août";
        case 8:
            return "Septembre";
        case 9:
            return "Octobre";
        case 10:
            return "Novembre";
        case 11:
            return "Décembre";
        default:
            return "Y'a eu un soucis";
    }
};
exports.textFromMonth = textFromMonth;
exports.OrderedDays = [...Array(7).keys()];
const getNextDayAndTime = (dayOfWeek, time) => {
    const dayOfWeekUs = (dayOfWeek + 1) % 7;
    const returnDate = new Date();
    returnDate.setDate(returnDate.getDate() + ((7 + dayOfWeekUs - returnDate.getDay()) % 7));
    returnDate.setHours(time / 3600000, (time % 3600000) / 60000, 0, 0);
    return returnDate;
};
exports.getNextDayAndTime = getNextDayAndTime;
//# sourceMappingURL=dates.js.map